import { render, staticRenderFns } from "./AddClaimSecondary.vue?vue&type=template&id=3ce1d433&scoped=true&"
import script from "./AddClaimSecondary.vue?vue&type=script&lang=js&"
export * from "./AddClaimSecondary.vue?vue&type=script&lang=js&"
import style0 from "./AddClaimSecondary.vue?vue&type=style&index=0&id=3ce1d433&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce1d433",
  null
  
)

export default component.exports